import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/auth/me")
      .then(({ data }) => alive && setUser(data))
      .catch(() => alive && setUser(false));
    return () => {
      alive = false;
    };
  }, []);

  const login = useCallback(async (phone, password) => {
    const { data } = await api.post("/auth/login", { phone, password });
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/distributors/register", payload);
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const refreshUser = useCallback(async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      tokenStore.clear();
      setUser(false);
    }
  }, []);

  return <AuthContext.Provider value={{ user, login, register, refreshUser, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
